import MatchedMap from 'utilities/src/matchedMap';

import { ButtonBGEnum } from '../../../../types/_bg';

import buttonSiteBlueLightTheme from './_light';
import buttonSiteBlueDarkTheme from './_dark';

export default new MatchedMap([
  [ButtonBGEnum.Light, buttonSiteBlueLightTheme],
  [ButtonBGEnum.Dark, buttonSiteBlueDarkTheme],
]);
